<template>
    <div>
        <Header/>
        <router-view class="wrapper"></router-view>
    </div>
</template>

<script>
import Header from '@/components/Header'
export default {
    components: {
        Header
    }
}
</script>